import React from "react";
import style from "../../styles/topicsCard.module.scss";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { Image } from "../ui/Image";

const Topic = ({
  reverse,
  img,
  title,
  description,
  descriptionItems,
  extraInfo,
}) => {
  return (
    <div className={reverse ? style.cardReverse : style.card}>
      <div className={style.images}>
        <Image img={img} desc={description} />
      </div>
      <div className={style.description}>
        <h2 className={style.topicTitle}>{title}</h2>
        <p className={style.topicDescription}>{description}</p>
        <ul>
          {descriptionItems.map((item) => (
            <li>
              <p>
                <IoIosCheckmarkCircleOutline className={style.iconStyle} />
              </p>
              <span>
                <p>{item}</p>
              </span>
            </li>
          ))}
        </ul>
        <p>{extraInfo}</p>
      </div>
    </div>
  );
};

export default Topic;
